module.exports = __webpack_public_path__ + "img/G.2ec9f0ce.svg";